export enum Method {
  Z_TEST = 'Z_TEST',
  GST_Z_TEST = 'GST_Z_TEST',
  ASYMP_CS = 'ASYMP_CS',
  RATIO = 'RATIO',
  GST_RATIO = 'GST_RATIO',
  ASYMP_CS_RATIO = 'ASYMP_CS_RATIO',
  QUANTILE = 'QUANTILE',
  GST_QUANTILE = 'GST_QUANTILE',
  ASYMP_CS_QUANTILE = 'ASYMP_CS_QUANTILE',
  UNKNOWN = 'UNKNOWN',
}

export enum MetricKind {
  SUCCESS = 'SUCCESS',
  GUARDRAIL = 'GUARDRAIL',
}
